module.exports = __webpack_public_path__ + "img/gk-guide-zhengce-img1.80b9047d.png";